import React, { useEffect } from 'react';
import { Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { BASE } from "../basedata/constants";
import DocumentInstructions from "../components/Intructions/DocumentInstructions";
import MobilePagination from '../components/MobilePagination/MobilePagination';
import { useTranslation } from 'react-i18next';
import "./FacialInstructionsPage.sass"
import { useStep } from '../context/StepContext'

const DocumentInstructionsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { setStep } = useStep();

  useEffect(() => {
    const verse_check = new URLSearchParams(location.search).get("verse") === "true";
    if(verse_check){
      setStep(5);
    }else{
      setStep(4);
    }
      
  }, []);

  const isVerse = new URLSearchParams(location.search).get("verse") === "true";
  return (
    <DocumentInstructions
      handleCloseInstructions={() => navigate(isVerse ? '/mobile-document?step=document_back' : '/mobile-document?step=document_front')}
      isVerse={isVerse}
      togglePanel={() => {}}
      />
  );
};

export default DocumentInstructionsPage;